const NoMatch = (props) => {
  return (
    <div>
      <div className="text-xl font-medium text-black">Page Not Found</div>
    </div>
  );
};

export default NoMatch;
